import React from 'react';
import { ValidatedSelect, ValidatedSelectItem } from '@cp-shared-19/frontend-ui';
import { CircumstancesOfDisaster } from 'cpfr-common';

type Props = {
    label: string;
    name: string;
    isMandatory?: boolean;
    selectId?: string;
};

export const CircumstancesOfDisasterSelection: React.FC<Props> = ({ label, name, isMandatory, selectId }) => {
    const list: CircumstancesOfDisaster[] = [
        'Vol du véhicule avec effraction',
        'Vol du véhicule sans effraction',
        'Collision',
        'Incendie',
    ];

    const selectItems: ValidatedSelectItem[] = list.map((item: CircumstancesOfDisaster) => {
        return { value: item, label: item };
    });

    return (
        <ValidatedSelect
            className="c-form-field--no-floating"
            label={label}
            id={selectId}
            name={name}
            testId={`test-${name}`}
            selectItems={selectItems}
            emptyByDefault
            required={isMandatory}
            isMandatory={isMandatory}
            requiredText=" *"
        />
    );
};
